import type { DeckType } from "../deck-type-chips"

export const getPlaceholderText = (
  isMobile: boolean,
  deckType: DeckType,
  subtype: string | null
) => {
  if (deckType === "fundraising-pitch-deck") {
    return "e.g. A pitch deck including problem, solution, business model, traction & team..."
  }

  if (deckType === "business-pitch-deck") {
    return "e.g. A business pitch introducing our company, services, market opportunity & team..."
  }

  if (deckType === "deep-research") {
    return "e.g. Detailed research on the electric vehicle battery market..."
  }

  if (deckType === "documents") {
    if (subtype === "partnership-proposal") {
      return "e.g. A partnership proposal between our software firm and a local agency..."
    }

    if (subtype === "NDA") {
      return "e.g. A mutual non-disclosure agreement for software development..."
    }

    if (subtype === "business-document") {
      return "e.g. A quarterly business review report for Q3..."
    }

    if (subtype === "service-agreement") {
      return "e.g. A standard service agreement for consulting work..."
    }

    return "e.g. A document covering our new remote work policy..."
  }

  // Default (Presentation)
  return "e.g. A sales deck for a coffee subscription service targeting startups..."
}